import { render, staticRenderFns } from "./PageBlank.vue?vue&type=template&id=4933f0e2"
import script from "./PageBlank.vue?vue&type=script&lang=js"
export * from "./PageBlank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports